<script setup lang="ts">
import { Divider } from "~/components/clarity-ui/Divider";
import CheckInComponent from "~/templates/components/shop/account/CheckInComponent.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import { Heading } from "~/components/clarity-ui/Heading";

defineEmits(["guest-proceed"]);

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>

<template>
  <div>
    <div class="grid max-w-md gap-6 xl:gap-7">
      <Heading size="medium" tag="h2">
        <CommonLabel path="BWF/shop/product/registration/productRegistrationGuestLabel" />
      </Heading>
      <button class="btn btn-ghost w-full" @click="$emit('guest-proceed')">
        <CommonLabel path="BWF/shop/product/registration/registrationGuestLabel" />
      </button>

      <Divider class="md:my-2 xl:my-5" />

      <CheckInComponent />
    </div>
  </div>
</template>
